export const GetParameter = {
	openNotifications: 'IM_NOTIFY',
	openHistory: 'IM_HISTORY',
	openChat: 'IM_DIALOG',
	openMessage: 'IM_MESSAGE',
	openLines: 'IM_LINES',
	openSettings: 'IM_SETTINGS',
	openCopilotChat: 'IM_COPILOT',
	openChannel: 'IM_CHANNEL',
	openCollab: 'IM_COLLAB',
	openSharedLink: 'IM_CODE',
	openTaskComments: 'IM_TASK',

	botContext: 'BOT_CONTEXT',

	desktopChatTabMode: 'IM_TAB',

	backgroundType: 'IM_BACKGROUND',
	legacyMode: 'IM_LEGACY',
};
